import RequestType from "../constants/requestType";
import ApiService from "../services/apiService";

import {actionTypes} from '../constants/actionTypes';
import {apiRoutes} from '../constants/apiRoutes';
import {toastr} from 'react-redux-toastr'

const getApiList = () => {
    return async (dispatch) => {
        try {
            let url = apiRoutes.apiLogRelated.getApiList;
            let response = await ApiService.performRequest(RequestType.GET, url);

            dispatch(_getApiListSuccess(response));
        } catch (error) {
            toastr.error('Het is niet mogelijk de gebruikers op te halen', error.message);
        }
    }
};

const _getApiListSuccess = (apiList) => {
    return {
        type: actionTypes.getApiList,
        payload: apiList
    }
};

const setSelectedApi = (api) => {
    return {
        type: actionTypes.setSelectedApi,
        payload: api
    }
}

const getAllApiLogs = (api, queryParameters) => {
    return async (dispatch) => {
        try {
            let url = apiRoutes.apiLogRelated.getApiLogs.replace('{api}', api) + (queryParameters ? queryParameters : '');
            let requestData = await ApiService.performRequest(RequestType.GET, url);

            dispatch(_getApiLogsSuccess(requestData));
            dispatch(_savePaginationParameters(requestData))
        }
        catch ({message}) {
            toastr.error('Het is niet mogelijk de lijst met offertes op te halen', message);
        }
    }
}

const _getApiLogsSuccess = ({apiLogs}) => {
    return {
        type: actionTypes.getApiLogs,
        payload: apiLogs
    }
};

const _savePaginationParameters = ({currentPage, resultsCount, pages}) => {
    return {
        type: actionTypes.saveApiLogPagination,
        payload: {
            currentPage,
            resultsCount,
            pages
        }
    }
};

const getApiLogDetails = (api, apiLogId) => {
    return async () => {
        try {
            let url = apiRoutes.apiLogRelated.getApiLogDetails
                .replace('{api}', api)
                .replace('{apiLogId}', apiLogId);
            return await ApiService.performRequest(RequestType.GET, url);
        }
        catch ({message}) {
            toastr.error('Het is niet mogelijk de lijst met offertes op te halen', message);
        }
    }
}

const updateApiLog = (api, apiLogId, apiLogData) => {
    return async () => {
        try {
            let url = apiRoutes.apiLogRelated.updateApiLog
                .replace('{api}', api)
                .replace('{apiLogId}', apiLogId);
            return await ApiService.performRequest(RequestType.PATCH, url, apiLogData);
        }
        catch ({message}) {
            toastr.error('Het is niet mogelijk de lijst met offertes op te halen', message);
        }
    }
}

export default {
    getApiList,
    setSelectedApi,
    getAllApiLogs,
    getApiLogDetails,
    updateApiLog
}
